import React from 'react';
import WithIframe from '@/app/components/WithIframe';

const AdvancedReports = () => {
    return <WithIframe url="/stm/report_list.php" />;
};

export default AdvancedReports;
